const FLEX_WINDOW_KEY = "__FLEX__";
const FLEX_WINDOW_GLOBAL_CONTEXTS_KEY = "global-contexts";

export { FLEX_WINDOW_GLOBAL_CONTEXTS_KEY, FLEX_WINDOW_KEY };
//# sourceMappingURL=windowFlex.mjs.map
